var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_61755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 18.3333L1.66667 18.3333",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.3333V4.99999C17.5 3.42864 17.5 2.64297 17.0118 2.15481C16.5237 1.66666 15.738 1.66666 14.1667 1.66666H12.5C10.9287 1.66666 10.143 1.66666 9.65482 2.15481C9.26187 2.54776 9.18523 3.1335 9.17029 4.16666",
    stroke: "#3F3F46",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.3333V7.49999C12.5 5.92864 12.5 5.14297 12.0118 4.65481C11.5237 4.16666 10.738 4.16666 9.16667 4.16666H5.83333C4.26198 4.16666 3.47631 4.16666 2.98816 4.65481C2.5 5.14297 2.5 5.92864 2.5 7.49999V18.3333",
    stroke: "#3F3F46",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.3333V15.8333",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 6.66666H10",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.16666H10",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.6667H10",
    stroke: "#3F3F46",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_61755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanies);
export default __webpack_public_path__ + "static/media/Companies.c0def6e2797d31474907d5c545f3ca7b.svg";
export { ForwardRef as ReactComponent };